import useApiUrl from '../../framework/hooks/useApiUrlHook';

export default function TeamSwiperItem({ teamMember }) {
    const apiUrl = useApiUrl();

    return (
        <a href={`medemerkers/${teamMember.url}`}>
            <div className="team-wrap slide-team">
                <div className="thumb">
                    <img
                        src={`${apiUrl}/img/extern/ratio/www.bandwerk.nl/medewerkers/orig/609/813/100/${teamMember.image}`}
                        alt="team"
                    />
                </div>
                <div className="signe"> {teamMember.functie} </div>
                <div className="title-1"> {teamMember.volledigenaam} </div>
                <div className="title-2"> {teamMember.voornaam} </div>
            </div>
        </a>
    );
}
